export default [
    {
        searchType: "常用",
        data: [
            {
                name: "百度",
                link: "https://www.baidu.com/s?wd=",
                placeholder: "百度一下你就知道"
            },
            {
                name: "微博",
                link: "https://s.weibo.com/weibo/",
                placeholder: "迅速搜索最热门话题"
            },
            {
                name: "翻译",
                link: "http://www.iciba.com/",
                placeholder: "iCIBA翻译"
            },
            {
                name: "电影",
                link: "https://v.yewan.org/search.php?searchword=",
                placeholder: "输入影视关键词"
            },
            {
                name: "微信",
                link: "https://weixin.sogou.com/weixin?type=2&query=",
                placeholder: "搜索微信文章"
            },
            {
                name: "知乎",
                link: "https://www.zhihu.com/search?type=content&q=",
                placeholder: "搜索知乎文章"
            },
            {
                name: "codelf",
                link: "https://codeif.xinke.org.cn/#",
                placeholder: "变量命名神器"
            },
            {
                name: "图标",
                link: "https://www.iconfont.cn/search/index?searchType=icon&q=",
                placeholder: "阿里图标搜索"
            },
            {
                name: "淘宝",
                link: "https://s.taobao.com/search?q=",
                placeholder: "淘宝网"
            },
            {
                name: "MDN",
                link: "https://developer.mozilla.org/zh-CN/search?q=",
                placeholder: "MDN Web 文档"
            },
            {
                name: "视频解析",
                link: "https://www.91jxs.com/jiexi/?url=",
                placeholder: "输入视频链接地址哦"
            }
        ]
    },
    {
        searchType: "搜索",
        data: [
            {
                name: "百度",
                link: "https://www.baidu.com/s?wd=",
                placeholder: "百度一下你就知道"
            },
            {
                name: "doge",
                link: "https://www.dogedoge.com/results?q=",
                placeholder: "不追踪，不误导"
            },
            {
                name: "必应",
                link: "https://cn.bing.com/search?q=",
                placeholder: "微软Bing搜索引擎"
            },
            {
                name: "搜狗",
                link: "https://www.sogou.com/web?query=",
                placeholder: "搜狗搜索"
            },
            {
                name: "360搜索",
                link: "https://www.so.com/s?q=",
                placeholder: "360搜索引擎"
            },
            {
                name: "秘迹",
                link: "https://mijisou.com/?q=",
                placeholder: "搜索..."
            },
            {
                name: "Google",
                link: "https://www.google.com/search?q=",
                placeholder: "谷歌搜索"
            },
            {
                name: "Yandex",
                link: "https://yandex.com/search/?text=",
                placeholder: "俄罗斯第一大搜索引擎"
            },
            {
                name: "神马",
                link: "https://yz.m.sm.cn/s?q=",
                placeholder: "神马是专注移动互联网的搜索引擎"
            },
            {
                name: "Magi",
                link: "https://magi.com/search?q=",
                placeholder: "梳理互联网的知识引擎"
            },
            {
                name: "Aol.",
                link: "https://search.aol.com/aol/search?q=",
                placeholder: "美国在线旗下搜索引擎网站"
            }
        ]
    },
    {
        searchType: "图片",
        data: [
            {
                name: "pxhere",
                link: "https://pxhere.com/zh/photos?q=",
                placeholder: "搜索图片"
            },
            {
                name: "Pexels",
                link: "https://www.pexels.com/search/",
                placeholder: "用英文搜索"
            },
            {
                name: "veer",
                link: "https://www.veer.com/query/image/?phrase=",
                placeholder: "小样免费，大图收费"
            },
            {
                name: "visualhunt",
                link: "https://visualhunt.com/search/instant/?q=",
                placeholder: "英文搜索"
            },
            {
                name: "pixabay",
                link: "https://pixabay.com/zh/images/search/",
                placeholder: "免费正版高清图片素材库"
            },

            {
                name: "500px",
                link: "https://500px.com/search?q=",
                placeholder: "500px"
            },

            {
                name: "colorhub",
                link: "https://colorhub.me/search?tag=",
                placeholder: "高清无版权图片，个人和商业用途免费"
            },
            {
                name: "ccSearch",
                link: "https://search.creativecommons.org/search?q=",
                placeholder: "最好用英文"
            }
        ]
    },
    {
        searchType: "电影",
        data: [
            {
                name: "影视库",
                link: "https://yingshiku.xunlei.com/search.html?q=",
                placeholder: "在影视库中搜索电影关键词"
            },
            {
                name: "疯狂影视",
                link: "http://ifkdy.com/search?key=",
                placeholder: "输入影视关键词"
            },
            {
                name: "upfox",
                link: "https://www.cupfox.com/search?key=",
                placeholder: "电影、剧集、动漫、节目......"
            }
        ]
    }, {
        searchType: "招聘",
        data: [
            {
                name: "boss",
                link: "https://www.zhipin.com/job_detail/?query=",
                placeholder: "搜索职位、公司"
            },
            {
                name: "拉钩",
                link: "https://www.lagou.com/jobs/list_",
                placeholder: "搜索职位、公司或地点"
            },
            {
                name: "猎聘",
                link: "https://www.liepin.com/zhaopin/?key=",
                placeholder: "输入职位关键词"
            },
            {
                name: "企查查",
                link: "https://www.qcc.com/search?key=",
                placeholder: "请输入企业名、人名、产品名、或地址电话..."
            }
        ]
    },
]